import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, Navigation, Icon, BottomSheet } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import useBreakpoint from 'hooks/useBreakpoint';
import { actions } from 'state/auth/slice';
import * as selectors from 'state/auth/selectors';
import Auth from '../Auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const AuthModal = () => {
  const translate = useTranslate('auth');
  const isOpen = useSelector(selectors.getIsAuthModalOpen);
  const dispatch = useDispatch();
  const breakpoints = useBreakpoint();

  function handleClose() {
    dispatch(actions.closeAuthModal());
  }

  if (breakpoints.phones) {
    return /*#__PURE__*/_jsx(BottomSheet, {
      isVisible: isOpen,
      onClose: handleClose,
      closeButtonEnabled: true,
      children: /*#__PURE__*/_jsx("div", {
        className: "u-ui-padding-top-x-large",
        children: /*#__PURE__*/_jsx(Auth, {})
      })
    });
  }

  return /*#__PURE__*/_jsx(Modal, {
    testId: "auth-modal",
    show: isOpen,
    defaultCallback: handleClose,
    closeOnOverlay: true,
    hasScrollableContent: true,
    className: "auth__container",
    aria: {
      labelledby: 'auth_modal_title'
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: "u-fill-width",
      children: [/*#__PURE__*/_jsx(Navigation, {
        right: /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(Icon, {
            name: "x"
          }),
          inverse: true,
          inline: true,
          onClick: handleClose,
          aria: {
            'aria-label': translate('a11y.close')
          }
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "u-overflow-auto",
        "aria-live": "polite",
        "aria-relevant": "additions",
        children: /*#__PURE__*/_jsx(Auth, {})
      })]
    })
  });
};

export default AuthModal;